import { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { message } from "antd";
import axios from "axios";
import { consts } from "../utils";
import * as _ from "lodash";
import { v4 as uuidv4 } from "uuid";

import styles from "./../styles/Component.module.css";
import api from "../config/api";

function UploadImageOne() {
  const [loading, setLoading] = useState(false);
  const [imageName, setImageName] = useState<string | null>(null);

  const [loadingTwo, setLoadingTwo] = useState(false);
  const [imageNameTwo, setImageNameTwo] = useState<string | null>(null);

  const handleChange = async (event: any) => {
    setLoading(true); // Show loading indicator while uploading
    setImageName("");
    try {
      let fileData = event.target.files[0];

      let fileName = fileData.name.split(".");
      let getImageType = _.last(fileName);
      let generateFileName = uuidv4() + "." + getImageType;

      // const fileData = info.file.name;
      if (!fileData) return message.warning("ກະລຸນາເລືອກຮູບກ່ອນ");

      // First, post to get the upload URL
      const responseUrl = await api.post("/file/uploadfile",{ name: generateFileName },);

      // Then, upload the file to the provided URL
      await axios.put(responseUrl.data.url, event.target.files[0], {
        headers: {
          "Content-Type": "file/*; image/*", // Set correct content-type
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
          "Access-Control-Allow-Headers":
            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
        },
      });

      // Set the uploaded image URL
      setImageName(generateFileName);
      message.success("ອັບໂຫຼດຮູບສຳເລັດ");
    } catch (error) {
      message.error("ອັບໂຫຼດຮູບບໍ່ສຳເລັດ");
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false); // Stop loading after upload
    }
  };

  const uploadButton = (
    <div style={{ border: 0, background: "none", textAlign: "center" }}>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>ອັບໂຫຼດຮູບ</div>
    </div>
  );

  const UploadImage = () => {
    return (
      <>
        <input
          type="file"
          id="file-upload"
          onChange={handleChange}
          style={{ display: "none" }}
          accept="image/png, image/jpeg, image/jpg"
          // capture="environment"
        />
        <label htmlFor="file-upload" className={styles.boxUploadImage}>
          {imageName ? (
            <img
              src={consts.URL_PHOTO_AW3 + imageName}
              alt="avatar"
              style={{ width: "100%", height: "100px", objectFit: "contain" }}
            />
          ) : (
            uploadButton
          )}
        </label>
      </>
    );
  };



  // ----------------- update img two --------------------------



  const handleChangetTwo = async (event: any) => {
    setLoadingTwo(true); // Show loading indicator while uploading
    setImageNameTwo("");
    try {
      let fileData = event.target.files[0];

      let fileName = fileData.name.split(".");
      let getImageType = _.last(fileName);
      let generateFileName = uuidv4() + "." + getImageType;

      // const fileData = info.file.name;
      if (!fileData) return message.warning("ກະລຸນາເລືອກຮູບກ່ອນ");

      // First, post to get the upload URL
      const responseUrl = await api.post("/file/uploadfile",{ name: generateFileName },);

      // Then, upload the file to the provided URL
      await axios.put(responseUrl.data.url, event.target.files[0], {
        headers: {
          "Content-Type": "file/*; image/*", // Set correct content-type
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
          "Access-Control-Allow-Headers":
            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
        },
      });

      // Set the uploaded image URL
      setImageNameTwo(generateFileName);
      message.success("ອັບໂຫຼດຮູບສຳເລັດ");
    } catch (error) {
      message.error("ອັບໂຫຼດຮູບບໍ່ສຳເລັດ");
      console.error(error);
      setLoadingTwo(false);
    } finally {
      setLoadingTwo(false); // Stop loading after upload
    }
  };

  const uploadButtontwo = (
    <div style={{ border: 0, background: "none", textAlign: "center" }}>
      {loadingTwo ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>ອັບໂຫຼດຮູບ</div>
    </div>
  );

  const UploadImageTwo = () => {
    return (
      <>
        <input
          type="file"
          id="file-upload-two"
          onChange={handleChangetTwo}
          style={{ display: "none" }}
          accept="image/png, image/jpeg, image/jpg"
          capture="environment"
        />
        <label htmlFor="file-upload-two" className={styles.boxUploadImage}>
          {imageNameTwo ? (
            <img
              src={consts.URL_PHOTO_AW3 + imageNameTwo}
              alt="avatar"
              style={{ width: "100%", height: "100px", objectFit: "contain" }}
            />
          ) : (
            uploadButtontwo
          )}
        </label>
      </>
    );
  };






  return { loading, UploadImage, imageName, setImageName,loadingTwo, UploadImageTwo, imageNameTwo, setImageNameTwo };
}

export default UploadImageOne;
